import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./locales/en/translation.json";
import translationTR from "./locales/tr/translation.json";
import translationAR from "./locales/ar/translation.json";
import translationJA from "./locales/ja/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
  ar: {
    translation: translationAR,
  },
  ja: {
    translation: translationJA,
  },
};

const applyDocumentDirection = (language) => {
  if (typeof document === "undefined") return;

  const normalizedLanguage = String(language || "en").toLowerCase();
  const isArabic =
    normalizedLanguage === "ar" || normalizedLanguage.startsWith("ar-");

  document.documentElement.setAttribute("dir", isArabic ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", normalizedLanguage);
  document.body.setAttribute("dir", isArabic ? "rtl" : "ltr");
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // default language
    fallbackLng: "en",
    supportedLngs: ["en", "tr", "ar", "ja"], // Add your supported languages here
    debug: true,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Path to your translation files
    },
  });

i18n.on("languageChanged", applyDocumentDirection);
applyDocumentDirection(i18n.resolvedLanguage || i18n.language);

export default i18n;
